const REQUIRED_ENV_KEYS = [
  'VITE_AWS_USER_POOL_ID',
  'VITE_AWS_USER_POOL_CLIENT_ID',
  'VITE_AWS_IDENTITY_POOL_ID',
  'VITE_AWS_REGION',
  'VITE_API_BASE_URL',
] as const;

type RequiredEnvKey = (typeof REQUIRED_ENV_KEYS)[number];

type RequiredEnv = Record<RequiredEnvKey, string>;

function requireEnv(key: RequiredEnvKey): string {
  const value = import.meta.env[key];
  if (!value || !value.trim()) {
    throw new Error(`Missing required environment variable: ${key}`);
  }

  return value;
}

function loadRequiredEnv(): RequiredEnv {
  const env = {} as RequiredEnv;

  for (const key of REQUIRED_ENV_KEYS) {
    env[key] = requireEnv(key);
  }

  return env;
}

export const ENV = loadRequiredEnv();

/** Production build flag. Lives here so `import.meta` stays confined to this
 * module — Jest maps it to a mock and cannot parse `import.meta` elsewhere. */
export const IS_PROD: boolean = import.meta.env.PROD;
